var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManageExpenses(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 832.27 600.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#252627;}.cls-2{fill:#54aae4;}.cls-3{fill:#fff;}.cls-4{isolation:isolate;}.cls-5{fill:#ffec00;}.cls-6{fill:#e3875f;}.cls-7{fill:#0e0e0e;}.cls-8{fill:#f09229;}.cls-9{fill:#a3a3a3;}.cls-10{fill:#343134;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Manage Expenses") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "284.62 231.41 533.37 374.96 248.75 539.29 0 395.74 284.62 231.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "131.2 427.86 418.41 262.04 418.41 4.09 131.2 169.92 131.2 427.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.2,428.36a.43.43,0,0,1-.25-.07.48.48,0,0,1-.25-.43V169.92a.5.5,0,0,1,.25-.44L418.16,3.66a.5.5,0,0,1,.5,0,.52.52,0,0,1,.25.44V262a.5.5,0,0,1-.25.43L131.45,428.29A.47.47,0,0,1,131.2,428.36Zm.5-258.16V427L417.91,261.75V5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "418.41 262.04 451.18 317.81 163.97 483.63 131.2 427.86 418.41 262.04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,484.13a.5.5,0,0,1-.43-.25l-32.77-55.77a.5.5,0,0,1-.06-.38.48.48,0,0,1,.24-.3L418.16,261.61a.5.5,0,0,1,.68.18l32.77,55.77a.5.5,0,0,1,.05.38.52.52,0,0,1-.23.3L164.22,484.06A.47.47,0,0,1,164,484.13ZM131.88,428,164.15,483,450.49,317.63l-32.26-54.91Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "451.18 317.81 642.65 428.36 355.44 594.18 163.97 483.63 451.18 317.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.44,594.68a.55.55,0,0,1-.25-.07L163.72,484.06a.49.49,0,0,1,0-.86L450.93,317.38a.5.5,0,0,1,.5,0L642.9,427.92a.5.5,0,0,1,0,.87L355.69,594.61A.59.59,0,0,1,355.44,594.68ZM165,483.63l190.47,110L641.65,428.36l-190.47-110Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "418.41 4.09 412.12 0.5 124.91 166.32 131.2 169.92 418.41 4.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.2,170.42a.52.52,0,0,1-.25-.07l-6.29-3.59a.5.5,0,0,1-.25-.44.48.48,0,0,1,.25-.43L411.87.07a.48.48,0,0,1,.49,0l6.29,3.59a.51.51,0,0,1,.26.43.52.52,0,0,1-.25.44L131.45,170.35A.59.59,0,0,1,131.2,170.42Zm-5.29-4.1,5.28,3L417.4,4.1l-5.28-3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "131.2 427.86 124.91 424.26 124.91 166.32 131.2 169.92 131.2 427.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.2,428.36a.43.43,0,0,1-.25-.07l-6.29-3.59a.5.5,0,0,1-.25-.43V166.32a.49.49,0,0,1,.74-.43l6.29,3.59a.51.51,0,0,1,.26.44V427.86a.5.5,0,0,1-.25.43A.47.47,0,0,1,131.2,428.36ZM125.41,424l5.29,3V170.21l-5.29-3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "355.44 594.18 355.44 600.47 163.97 489.92 163.97 483.63 355.44 594.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.44,601a.55.55,0,0,1-.25-.07L163.72,490.35a.48.48,0,0,1-.25-.43v-6.29a.48.48,0,0,1,.25-.43.5.5,0,0,1,.5,0L355.69,593.74a.52.52,0,0,1,.25.44v6.29a.5.5,0,0,1-.25.43A.59.59,0,0,1,355.44,601Zm-191-111.34,190.47,110v-5.13l-190.47-110Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "642.65 428.36 642.65 434.65 355.44 600.47 355.44 594.18 642.65 428.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.44,601a.55.55,0,0,1-.25-.07.48.48,0,0,1-.25-.43v-6.29a.5.5,0,0,1,.25-.44L642.4,427.92a.5.5,0,0,1,.5,0,.52.52,0,0,1,.25.44v6.29a.52.52,0,0,1-.25.43L355.69,600.9A.59.59,0,0,1,355.44,601Zm.5-6.5v5.13L642.15,434.36v-5.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "163.97 483.63 131.2 427.86 124.91 424.26 163.97 489.92 163.97 483.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,490.42a.5.5,0,0,1-.43-.24l-39.06-65.66a.5.5,0,0,1,.67-.69l6.29,3.6a.47.47,0,0,1,.19.18l32.77,55.77a.52.52,0,0,1,.07.25v6.29a.5.5,0,0,1-.37.48Zm-37.66-64.78,37.16,62.46v-4.33l-32.64-55.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M367.09,559.93a.32.32,0,0,1-.14,0l-41.18-16.29L210.56,477.1a.39.39,0,0,1-.19-.33.36.36,0,0,1,.19-.32L435.35,346.66a.45.45,0,0,1,.19-.05.41.41,0,0,1,.19.05l149.86,86.52a.37.37,0,0,1,.19.33.36.36,0,0,1-.19.32L367.27,559.88A.37.37,0,0,1,367.09,559.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.54,347l149.87,86.53-218.32,126-41.18-16.3L210.74,476.77,435.54,347m0-.75a.79.79,0,0,0-.37.1L210.37,476.12a.76.76,0,0,0-.38.65.75.75,0,0,0,.38.65l115.17,66.49.1.05,41.17,16.29a.67.67,0,0,0,.28.06.79.79,0,0,0,.37-.1l218.32-126a.76.76,0,0,0,.38-.65.75.75,0,0,0-.38-.65L435.92,346.33a.86.86,0,0,0-.38-.1Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M525.56,411.71c4.38,2.52,5.7,5.45,1,8.17l-.69.4-4.74-2.73c2.33-1.36,2.89-2.54,1-3.66a5.37,5.37,0,0,0-5.64,0c-1.51.88-2,1.68-.75,3.39l2.17,3.15c2,3.07,1.2,4.69-1.79,6.42-5.13,3-10.62,2.51-16-.57-5.58-3.23-5.18-6-.69-8.6l1-.58,4.94,2.85-.72.42c-2.27,1.32-3.11,2.55-.51,4.05a6.14,6.14,0,0,0,6,0c2.17-1.27,2-2.43-.26-5-2.92-3.37-3.06-5.64.95-8A14.2,14.2,0,0,1,525.56,411.71Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "549.59 426.14 545.58 428.47 536.83 423.43 531.11 426.75 539.34 431.5 535.33 433.83 527.1 429.08 520.56 432.88 529.64 438.13 525.62 440.46 511.61 432.36 535.91 418.24 549.59 426.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.85,431.5c4.37,2.53,5.69,5.45,1,8.17l-.69.4-4.74-2.73c2.33-1.35,2.89-2.54,1-3.64a5.37,5.37,0,0,0-5.66,0c-1.51.88-2,1.7-.75,3.39l2.17,3.15c2.07,3.09,1.21,4.69-1.78,6.43-5.14,3-10.63,2.51-15.95-.57-5.61-3.23-5.21-6-.72-8.61l1-.58,4.94,2.85-.72.42c-2.27,1.32-3.11,2.55-.49,4.07a6.13,6.13,0,0,0,5.95-.06c2.17-1.26,2-2.41-.23-4.93-2.94-3.39-3.09-5.66.93-8A14.22,14.22,0,0,1,559.85,431.5Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "514.66 405.98 490.37 420.1 484.76 416.86 495.73 403.48 478.66 413.34 474.14 410.73 498.44 396.61 504.12 399.89 493.45 413 510.14 403.37 514.66 405.98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.77,381.79c5,2.91,3.08,6-.57,8.11a14.54,14.54,0,0,1-15.07-.24l-2.65-1.53-9.71,5.64-4.94-2.85,24.3-14.12Zm-12.48,5.52a6.71,6.71,0,0,0,6.92-.2c2.43-1.41,2.78-2.75.31-4.18l-2.06-1.18L458.08,386l2.21,1.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "461.79 375.45 444.1 379.15 437.9 389.81 432.37 386.62 437.05 379.79 425.32 382.55 419.93 379.43 438.31 375.81 444.69 365.58 450.14 368.73 445.43 375.12 456.41 372.35 461.79 375.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "442.91 364.55 438.9 366.88 430.16 361.83 424.43 365.16 432.66 369.91 428.65 372.24 420.42 367.49 413.88 371.29 422.96 376.54 418.95 378.87 404.93 370.77 429.23 356.65 442.91 364.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "495.61 394.98 491.6 397.31 482.85 392.26 477.13 395.58 485.36 400.34 481.35 402.67 473.12 397.92 466.58 401.72 475.65 406.96 471.64 409.29 457.63 401.2 481.93 387.08 495.61 394.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.91 543.26 367.09 559.56 360.61 543.26 325.91 543.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "480.27 442.29 540.69 407.41 477.44 370.89 414.04 407.5 460.2 434.02 480.27 442.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.31,442.85,460,434.48l-47-27,64.4-37.19,64.25,37.1ZM415,407.5l45.41,26.09,19.79,8.15,59.45-34.33-62.25-35.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.2,434l20.8.52s-3,6.49-.72,7.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.29,397a9.52,9.52,0,0,1-4.7-1.08,3.52,3.52,0,0,1-2-3c0-1.53,1.15-3.07,3.15-4.23l17.43-10.07c3.48-2,8.9-2.16,12.09-.32a4.16,4.16,0,0,1,2.38,3.5c0,1.51-1.06,3-2.92,4.06l-10.32,6a.5.5,0,0,1-.5-.86l10.32-6c1.54-.89,2.42-2.06,2.42-3.2a3.21,3.21,0,0,0-1.88-2.63c-2.92-1.68-7.89-1.54-11.09.31l-17.43,10.08c-1.65,1-2.64,2.21-2.65,3.36a2.53,2.53,0,0,0,1.47,2.14c2.5,1.47,7.28,1.17,10.43-.65l13.74-7.93a.51.51,0,0,1,.68.19.49.49,0,0,1-.18.68L505,395.28A13.9,13.9,0,0,1,498.29,397Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M435.78,573.62a3.35,3.35,0,0,0-1.63-2.6,1.28,1.28,0,0,0-.29-.14l9.44-8,.12-.06a1.65,1.65,0,0,1,.22-.16,3,3,0,0,1,1.42-.33,2.91,2.91,0,0,1,1.41.33c.47.27,2.45,3.13,2.34,4.14a6.16,6.16,0,0,0,0,.86,1.31,1.31,0,0,1-.68,1.15.8.8,0,0,1-.22.13l-12.13,4.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.06,562.7a2.52,2.52,0,0,1,1.21.28c.51.35,2.25,3,2.17,3.78a5.85,5.85,0,0,0,0,.94c0,.33-.14.54-.53.81h0l0,0-.08.05h0l-11.68,4.57a3.88,3.88,0,0,0-1.59-2.34l9-7.6.12-.07,0,0,.05,0,.13-.09a2.54,2.54,0,0,1,1.23-.29m0-.75a3.28,3.28,0,0,0-1.61.39l-.21.15-.18.1-10.18,8.62a.75.75,0,0,1,.37-.09,1.51,1.51,0,0,1,.72.22,3,3,0,0,1,1.44,2.28.77.77,0,0,1-.42.77l13.08-5.11a.92.92,0,0,0,.27-.16,1.68,1.68,0,0,0,.85-1.42,7.3,7.3,0,0,1,0-.86c.13-1.19-1.93-4.16-2.52-4.5a3.21,3.21,0,0,0-1.6-.39Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M449.35,568.11a3,3,0,0,0,0-.54v-.11a6.44,6.44,0,0,0-1.89-4,6.53,6.53,0,0,0-1.44-1.17,4.43,4.43,0,0,0-1-.43l136.15-79,2.76,1.6,1.39,3.6L584,490Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.21,483.29l2.45,1.43,1.28,3.28-1.21,1.7-134,77.73a6.84,6.84,0,0,0-2-4.22,6.54,6.54,0,0,0-1.55-1.25,3.07,3.07,0,0,0-.31-.17l135.29-78.5m0-.86L443.69,562.22a1.63,1.63,0,0,1,.59-.1,3.25,3.25,0,0,1,1.58.49,6.29,6.29,0,0,1,1.37,1.11,6.15,6.15,0,0,1,1.79,3.74v.11a1.75,1.75,0,0,1-.67,1.55l135.9-78.85,1.53-2.16-1.51-3.91-3.06-1.77Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "428.69 575.94 428.53 575.55 428.68 575.63 428.83 576.03 428.69 575.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "428.39 575.03 428.09 575.45 428.39 576.2 428.98 576.54 429.27 576.13 428.98 575.37 428.39 575.03 428.39 575.03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.81,576.18a.45.45,0,0,1-.45-.44.46.46,0,0,1,.23-.38l.28-.16,0-.05,4.12-3.5.18-.16h.12a1.12,1.12,0,0,1,.54.17,2.67,2.67,0,0,1,1.25,2c0,.13,0,.35-.19.42h.06c-.22.07-1.16.4-5.89,2.09l-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.28,571.87a.66.66,0,0,1,.32.12,2.24,2.24,0,0,1,1.07,1.63.31.31,0,0,1,0,.11c-.5.16-1.85.64-5.76,2l-.09,0h0a.08.08,0,0,1-.05-.07s0,0,0,0l.54-.32,0-.1,3.93-3.34.07-.06m0-.75a.71.71,0,0,0-.36.09l-.18.15S428.39,575,428.4,575a.81.81,0,0,0,.41,1.52l.15,0h0l.19-.06,5.84-2.09a.76.76,0,0,0,.42-.77,3,3,0,0,0-1.44-2.28,1.45,1.45,0,0,0-.72-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.65,490.79a4.58,4.58,0,0,0,0-.55,5.72,5.72,0,0,0-1-3,7.21,7.21,0,0,0-2.36-2.34,4.45,4.45,0,0,0-1-.42l6.66-3.85a1.21,1.21,0,0,1,.47-.08,2.87,2.87,0,0,1,1.39.44,6.46,6.46,0,0,1,2.11,2.09,5.12,5.12,0,0,1,.86,2.57,1.35,1.35,0,0,1-.69,1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.51,481a2.37,2.37,0,0,1,1.2.39,5.93,5.93,0,0,1,2,1.95,4.76,4.76,0,0,1,.81,2.38c0,.3-.07.83-.47,1l0,0,0,0-5.89,3.4a6.1,6.1,0,0,0-1-3.05,7.58,7.58,0,0,0-2.49-2.46l-.3-.16,5.73-3.32.22-.12a.8.8,0,0,1,.32-.05m0-.75a1.67,1.67,0,0,0-.65.12l-.26.15L577,484.9a1.76,1.76,0,0,1,.66-.13,3.16,3.16,0,0,1,1.55.49,6.72,6.72,0,0,1,2.23,2.21,5.35,5.35,0,0,1,.93,2.77,1.77,1.77,0,0,1-.68,1.56l7.68-4.43a1.69,1.69,0,0,0,.93-1.69,5.48,5.48,0,0,0-.93-2.78,6.79,6.79,0,0,0-2.23-2.2,3.22,3.22,0,0,0-1.58-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M575.37,495a3,3,0,0,0,0-.55,5.71,5.71,0,0,0-1-3,7.12,7.12,0,0,0-2.36-2.34,4.08,4.08,0,0,0-1-.43l6.68-3.88a1.37,1.37,0,0,1,.45-.07,2.85,2.85,0,0,1,1.4.45,6.16,6.16,0,0,1,2.11,2.08,5.08,5.08,0,0,1,.87,2.57,1.34,1.34,0,0,1-.7,1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.2,485.16a2.53,2.53,0,0,1,1.22.4,6,6,0,0,1,2,2,4.7,4.7,0,0,1,.81,2.37c0,.3-.06.84-.46,1l0,0,0,0-5.86,3.41a6.19,6.19,0,0,0-1-3,7.62,7.62,0,0,0-2.49-2.47l-.33-.17,5.76-3.34.21-.12a.94.94,0,0,1,.3,0m0-.75a1.61,1.61,0,0,0-.63.12l-.26.15-7.66,4.45a1.73,1.73,0,0,1,.66-.12,3.18,3.18,0,0,1,1.58.49,6.92,6.92,0,0,1,2.23,2.21,5.43,5.43,0,0,1,.92,2.76,1.79,1.79,0,0,1-.68,1.57l7.67-4.45a1.7,1.7,0,0,0,.92-1.7,5.55,5.55,0,0,0-.92-2.77,6.76,6.76,0,0,0-2.24-2.21,3.31,3.31,0,0,0-1.59-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M569.65,489.14a1.66,1.66,0,0,1,.42-.11,2.67,2.67,0,0,1,1.14.16,6.11,6.11,0,0,1,2.67,2.2,5.45,5.45,0,0,1,1.14,3.26,1.94,1.94,0,0,1-.35,1.08,1.21,1.21,0,0,1-.31.3s.16-.06.35-.27a1.9,1.9,0,0,0,.42-1.11,4,4,0,0,0-.22-1.66,6.73,6.73,0,0,0-.87-1.71,7,7,0,0,0-1.33-1.39,4.65,4.65,0,0,0-1.46-.81,2.55,2.55,0,0,0-1.18-.1,1.8,1.8,0,0,0-.43.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.44,489a3.46,3.46,0,0,0-.37,0,1.8,1.8,0,0,0-.43.14v0a1.66,1.66,0,0,1,.42-.11h.23a2.81,2.81,0,0,1,.91.17,6.11,6.11,0,0,1,2.67,2.2,5.45,5.45,0,0,1,1.14,3.26,1.94,1.94,0,0,1-.35,1.08,1.21,1.21,0,0,1-.31.3h0a.72.72,0,0,0,.35-.27,1.9,1.9,0,0,0,.42-1.11,4,4,0,0,0-.22-1.66,6.73,6.73,0,0,0-.87-1.71,7,7,0,0,0-1.33-1.39,4.65,4.65,0,0,0-1.46-.81,2.83,2.83,0,0,0-.81-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M571.55,488.06A1.28,1.28,0,0,1,572,488a2.37,2.37,0,0,1,1.13.16,6,6,0,0,1,2.67,2.2,5.45,5.45,0,0,1,1.14,3.25,1.94,1.94,0,0,1-.35,1.08,1.21,1.21,0,0,1-.31.3s.16-.05.35-.27a1.91,1.91,0,0,0,.43-1.1,4.23,4.23,0,0,0-.23-1.67,6.9,6.9,0,0,0-.87-1.71,7.94,7.94,0,0,0-1.32-1.39,4.76,4.76,0,0,0-1.47-.8,2.42,2.42,0,0,0-1.18-.1,1.24,1.24,0,0,0-.42.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.35,487.87a2.09,2.09,0,0,0-.38,0,1.24,1.24,0,0,0-.42.14v0A1.28,1.28,0,0,1,572,488l.22,0a2.61,2.61,0,0,1,.91.18,6,6,0,0,1,2.67,2.2,5.45,5.45,0,0,1,1.14,3.25,1.94,1.94,0,0,1-.35,1.08,1.21,1.21,0,0,1-.31.3h0a.85.85,0,0,0,.34-.28,1.91,1.91,0,0,0,.43-1.1,4.25,4.25,0,0,0-.23-1.67,6.9,6.9,0,0,0-.87-1.71,7.94,7.94,0,0,0-1.32-1.39,4.76,4.76,0,0,0-1.47-.8,2.5,2.5,0,0,0-.8-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M571.44,488.1a1.66,1.66,0,0,1,.42-.11,2.67,2.67,0,0,1,1.14.16,6.16,6.16,0,0,1,2.67,2.2,5.45,5.45,0,0,1,1.14,3.26,1.94,1.94,0,0,1-.35,1.08,1.21,1.21,0,0,1-.31.3s.16-.06.35-.27a2,2,0,0,0,.42-1.11,4.16,4.16,0,0,0-.22-1.66,6.77,6.77,0,0,0-.88-1.71,7,7,0,0,0-1.32-1.39A4.58,4.58,0,0,0,573,488a2.5,2.5,0,0,0-1.17-.1,1.6,1.6,0,0,0-.43.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.23,487.91a2,2,0,0,0-.37,0,1.6,1.6,0,0,0-.43.14v0a1.66,1.66,0,0,1,.42-.11h.22a2.87,2.87,0,0,1,.92.17,6.16,6.16,0,0,1,2.67,2.2,5.45,5.45,0,0,1,1.14,3.26,1.94,1.94,0,0,1-.35,1.08,1.21,1.21,0,0,1-.31.3h0a1,1,0,0,0,.35-.27,2,2,0,0,0,.42-1.11,4.16,4.16,0,0,0-.22-1.66,6.77,6.77,0,0,0-.88-1.71,7,7,0,0,0-1.32-1.39A4.58,4.58,0,0,0,573,488a2.72,2.72,0,0,0-.8-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M576.23,485.33a1.67,1.67,0,0,1,.43-.11,2.65,2.65,0,0,1,1.13.16,6.05,6.05,0,0,1,2.67,2.2,5.45,5.45,0,0,1,1.14,3.26,1.94,1.94,0,0,1-.35,1.08,1.21,1.21,0,0,1-.31.3s.16-.06.35-.27a2,2,0,0,0,.43-1.11,4,4,0,0,0-.23-1.66,6.73,6.73,0,0,0-.87-1.71,7.3,7.3,0,0,0-1.32-1.39,5,5,0,0,0-1.47-.81,2.39,2.39,0,0,0-1.18-.09,1.42,1.42,0,0,0-.42.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577,485.14a2,2,0,0,0-.38,0,1.42,1.42,0,0,0-.42.13v0a1.67,1.67,0,0,1,.43-.11h.22a2.81,2.81,0,0,1,.91.17,6.05,6.05,0,0,1,2.67,2.2,5.45,5.45,0,0,1,1.14,3.26,1.94,1.94,0,0,1-.35,1.08,1.21,1.21,0,0,1-.31.3h0a.77.77,0,0,0,.34-.27,2,2,0,0,0,.43-1.11,4,4,0,0,0-.23-1.66,6.73,6.73,0,0,0-.87-1.71,7.3,7.3,0,0,0-1.32-1.39,5,5,0,0,0-1.47-.81,2.77,2.77,0,0,0-.8-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M576.12,485.38a1.26,1.26,0,0,1,.42-.11,2.39,2.39,0,0,1,1.14.16,6,6,0,0,1,2.67,2.2,5.45,5.45,0,0,1,1.14,3.25,1.94,1.94,0,0,1-.35,1.08,1.42,1.42,0,0,1-.31.31s.16-.06.35-.28a1.84,1.84,0,0,0,.42-1.1,4.06,4.06,0,0,0-.22-1.67,6.68,6.68,0,0,0-.87-1.7,7.3,7.3,0,0,0-1.32-1.39,4.6,4.6,0,0,0-1.47-.81,2.42,2.42,0,0,0-1.18-.1,1.37,1.37,0,0,0-.43.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.92,485.19a2,2,0,0,0-.38,0,1.37,1.37,0,0,0-.43.14v0a1.26,1.26,0,0,1,.42-.11l.23,0a2.61,2.61,0,0,1,.91.18,6,6,0,0,1,2.67,2.2,5.45,5.45,0,0,1,1.14,3.25,1.94,1.94,0,0,1-.35,1.08,1.42,1.42,0,0,1-.31.31h0a.78.78,0,0,0,.35-.28,1.84,1.84,0,0,0,.42-1.1,4.06,4.06,0,0,0-.22-1.67,6.68,6.68,0,0,0-.87-1.7,7.3,7.3,0,0,0-1.32-1.39,4.6,4.6,0,0,0-1.47-.81,2.5,2.5,0,0,0-.8-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M443.36,562.43l.33-.2A.94.94,0,0,0,443.36,562.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.69,562.23a.94.94,0,0,0-.33.2l.33-.2Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M831.77,311.45a7.18,7.18,0,0,1-2.34,5.07,12.83,12.83,0,0,1-2.73,2.06l-1.56.91-144,83.68c-6.8,3.95-17.9,3.94-24.74,0L456.86,288l-11.57-6.68a12.87,12.87,0,0,1-2.82-2.14,7.2,7.2,0,0,1-2.34-5.07,6.14,6.14,0,0,1,.54-2.49A10.35,10.35,0,0,1,445.2,267l145.55-84.59c6.8-4,17.9-4,24.74,0L826.61,304.25a14.27,14.27,0,0,1,1.67,1.12C830.61,307.17,831.77,309.31,831.77,311.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.8,406.62a26,26,0,0,1-12.65-3L445,281.72a13.61,13.61,0,0,1-2.92-2.23,7.67,7.67,0,0,1-2.49-5.42,6.63,6.63,0,0,1,.59-2.69,10.92,10.92,0,0,1,4.73-4.86L590.5,181.93c7-4,18.27-4,25.24,0L826.86,303.82a14.91,14.91,0,0,1,1.73,1.16c2.41,1.86,3.68,4.1,3.68,6.47a7.73,7.73,0,0,1-2.48,5.43A13.79,13.79,0,0,1,827,319l-1.55.9-144,83.68A25.59,25.59,0,0,1,668.8,406.62ZM603.1,179.89a24.63,24.63,0,0,0-12.09,2.9L445.45,267.38a9.93,9.93,0,0,0-4.32,4.4,5.74,5.74,0,0,0-.5,2.29,6.72,6.72,0,0,0,2.2,4.72,12.53,12.53,0,0,0,2.71,2.06L656.65,402.73c6.71,3.87,17.59,3.88,24.24,0l145.56-84.59a12.64,12.64,0,0,0,2.63-2,6.71,6.71,0,0,0,2.19-4.72c0-2.05-1.14-4-3.29-5.68a12.67,12.67,0,0,0-1.62-1.08L615.24,182.81A24.67,24.67,0,0,0,603.1,179.89Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M831.77,311.45v10.14c0,2.58-1.69,5.16-5.07,7.12l-1.56.91-144,83.68c-6.8,3.95-17.9,3.95-24.74,0L445.29,291.41a12.13,12.13,0,0,1-3.67-3.1,6.75,6.75,0,0,1-1.49-4.1V274.07a7.2,7.2,0,0,0,2.34,5.07,12.87,12.87,0,0,0,2.82,2.14L456.86,288,656.4,403.16c6.84,3.95,17.94,4,24.74,0l144-83.68,1.56-.91a12.83,12.83,0,0,0,2.73-2.06A7.18,7.18,0,0,0,831.77,311.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.79,416.76a25.8,25.8,0,0,1-12.64-3L445,291.85a12.68,12.68,0,0,1-3.82-3.24,7.28,7.28,0,0,1-1.59-4.4V274.07h1a6.72,6.72,0,0,0,2.2,4.72,12.53,12.53,0,0,0,2.71,2.06L656.65,402.73c6.71,3.87,17.59,3.88,24.24,0l145.56-84.59a12.64,12.64,0,0,0,2.63-2,6.71,6.71,0,0,0,2.19-4.72h1v10.14c0,2.88-1.89,5.57-5.32,7.55l-1.55.91-144,83.68A25.63,25.63,0,0,1,668.79,416.76ZM440.63,277.6v6.61A6.23,6.23,0,0,0,442,288a11.73,11.73,0,0,0,3.52,3L656.65,412.87c6.71,3.87,17.58,3.87,24.24,0l145.56-84.59c3.11-1.8,4.82-4.18,4.82-6.69V315a9.49,9.49,0,0,1-1.48,1.9A13.79,13.79,0,0,1,827,319l-1.55.9-144,83.68c-6.94,4-18.26,4-25.25,0L445,281.72a13.61,13.61,0,0,1-2.92-2.23A9.59,9.59,0,0,1,440.63,277.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M812.27,307.16c3.63,2.1,3.65,5.49,0,7.59l-137,79.6a14.43,14.43,0,0,1-13.11,0L460.15,277.68c-3.63-2.09-3.64-5.49,0-7.59l137-79.6a14.43,14.43,0,0,1,13.11,0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 665.86,
    cy: 255.62,
    rx: 8.73,
    ry: 15.08,
    transform: "translate(408.19 920.69) rotate(-89.82)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 635.42,
    cy: 273.19,
    rx: 8.73,
    ry: 15.08,
    transform: "translate(360.27 907.77) rotate(-89.82)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 604.93,
    cy: 290.72,
    rx: 8.73,
    ry: 15.08,
    transform: "translate(312.34 894.75) rotate(-89.82)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 574.6,
    cy: 308.32,
    rx: 8.73,
    ry: 15.08,
    transform: "translate(264.5 881.96) rotate(-89.82)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 690.11,
    cy: 269.62,
    rx: 8.73,
    ry: 15.08,
    transform: "translate(418.36 958.89) rotate(-89.82)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 659.67,
    cy: 287.19,
    rx: 8.73,
    ry: 15.08,
    transform: "translate(370.44 945.97) rotate(-89.82)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 629.18,
    cy: 304.72,
    rx: 8.73,
    ry: 15.08,
    transform: "translate(322.51 932.95) rotate(-89.82)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 598.84,
    cy: 322.32,
    rx: 8.73,
    ry: 15.08,
    transform: "translate(274.67 920.16) rotate(-89.82)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 714.25,
    cy: 283.62,
    rx: 8.73,
    ry: 15.08,
    transform: "translate(428.42 997) rotate(-89.82)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 683.81,
    cy: 301.2,
    rx: 8.73,
    ry: 15.08,
    transform: "translate(380.5 984.07) rotate(-89.82)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 653.32,
    cy: 318.72,
    rx: 8.73,
    ry: 15.08,
    transform: "translate(332.58 971.06) rotate(-89.82)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 622.99,
    cy: 336.32,
    rx: 8.73,
    ry: 15.08,
    transform: "translate(284.74 958.27) rotate(-89.82)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 738.62,
    cy: 297.63,
    rx: 8.73,
    ry: 15.08,
    transform: "translate(438.71 1035.33) rotate(-89.82)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 708.18,
    cy: 315.2,
    rx: 8.73,
    ry: 15.08,
    transform: "translate(390.8 1022.41) rotate(-89.82)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 677.69,
    cy: 332.73,
    rx: 8.73,
    ry: 15.08,
    transform: "translate(342.87 1009.39) rotate(-89.82)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 647.36,
    cy: 350.33,
    rx: 8.73,
    ry: 15.08,
    transform: "translate(295.03 996.6) rotate(-89.82)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 762.94,
    cy: 311.62,
    rx: 8.73,
    ry: 15.08,
    transform: "translate(448.96 1073.59) rotate(-89.82)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 732.5,
    cy: 329.19,
    rx: 8.73,
    ry: 15.08,
    transform: "translate(401.04 1060.67) rotate(-89.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M713.18,340.87l-.62-.35s0,0,.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M713.22,352.57l-.65.39-.05,0-29.63,17.19-.65.39c-5.82,3.31-15.25,3.31-21.11,0l-.64-.38c-5.16-3.29-5.18-8.38,0-11.69l.65-.39,30.21-17.53c5.75-3.35,15.15-3.39,21.06-.14l0,0,.14.08.62.35C718.34,344.19,718.36,349.27,713.22,352.57Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 373.69,
    cy: 392.73,
    rx: 2.51,
    ry: 4.33,
    transform: "translate(-20.19 765.2) rotate(-89.82)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 283.69,
    cy: 444.73,
    rx: 2.51,
    ry: 4.33,
    transform: "translate(-161.91 727.04) rotate(-89.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M550.63,256.22l17.28,10.39-2.06,1.19-13-7.81-3.71,2.15-1.47-.88c2.07-1.34,3.82-2.64,1.47-4.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M560.9,250.29c4.72-2.72,9.62-.06,13.84,2.48,3.64,2.18,8.5,5.39,3.78,8.11s-9.6.08-13.7-2.38C561,256.21,556.19,253,560.9,250.29Zm16,9.63c2.65-1.53-.69-3.72-4.32-5.9-3.81-2.29-7.42-4.29-10.08-2.76s.67,3.7,4.48,6c3.63,2.18,7.27,4.2,9.92,2.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M572.69,243.48c4.72-2.72,9.62-.06,13.84,2.48,3.64,2.19,8.5,5.4,3.78,8.12s-9.6.07-13.7-2.39C572.81,249.4,568,246.21,572.69,243.48Zm16,9.63c2.65-1.53-.69-3.72-4.32-5.9-3.81-2.29-7.42-4.29-10.08-2.76s.67,3.7,4.48,6c3.63,2.19,7.27,4.2,9.92,2.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M597.35,246.56l2.13,1.28c1.85,1.11,3.31,2.19,1.81,3.75l-1.14-.69c.44-.74.17-1.16-.81-1.75l-.58-.35-1.08.62-2.59-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M591.9,232.4l17.27,10.38L607.11,244l-13-7.8-3.71,2.14-1.46-.88c2.06-1.34,3.81-2.63,1.46-4.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M628.49,224.64l2-1.13,1.75,1.05-2,1.14,4.17,2.51-2.06,1.19-4.17-2.51-6.29,3.63L620,229.36,615.08,219l2.07-1.19Zm-2.06,1.19-8-4.8-.05,0,3.61,7.32,4.42-2.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M606.76,224.22l1.9,1.15-6.11,3.53,4.31,3.4h.1c-.15-.92.57-1.85,1.75-2.53,2.63-1.52,6.42-1.3,10.06.89,3.22,1.94,4.5,4.39.87,6.49a9.58,9.58,0,0,1-9.55-.13l2.16-1.25c.9.55,3.52,1.71,5.83.38s.11-3.29-1.65-4.34-4.61-1.94-6.8-.68c-1.5.87-1.19,2.18-.77,2.43l-2,1L599,228.7Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageExpenses);
export default __webpack_public_path__ + "static/media/ManageExpenses.0516799105fa856ad3abfbce2a02f215.svg";
export { ForwardRef as ReactComponent };